import { render } from "./BaseSelect.vue?vue&type=template&id=4d6a7295"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script